module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/features/4-14290a86fae7a4433c502c9529514783.svg";